(ns ui.view.nev.entity-specific-actions
  (:require
   [common.entity :as common-entity]
   [ui.view.nev.sub :as sub]
   [ui.view.nev.event :as event]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [common.localization :as loc]
   [common.util :as cu]
   [clojure.string :as string]
   [re-frame.core :as rf]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.view.entity :as entity]
   [common.schema.entity-types :as entity-types]
   [ui.view.counterparty-diligence.send-to-responders-modal.view :as cpd-responder-modal]))

(defn new-linked-entity-initial-values
  [linked-entity-type selected-entity-id]
  (let [values {:entity.type/oppo {:oppo/target-asset selected-entity-id}
                :entity.type/investor {:investor/legal-entity selected-entity-id}
                :entity.type/holding {:holding/target-asset selected-entity-id}
                :entity.type/fof-asset {:fof-asset/gp selected-entity-id}
                :entity.type/sale-agreement {:sale-agreement/customer selected-entity-id}}]
    (get values linked-entity-type)))

(defn add-linked-entity-button-or-dropdown
  [{:keys [entity-type ctx]}]
  (let [selected-entity-id @(rf/subscribe [::sub/selected-entity-id ctx])
        selected-entity @(rf/subscribe [::sub/selected-entity ctx])
        all-cached-entities @(rf/subscribe [::sub/all-cached-entities ctx])
        existing-investor? (->> all-cached-entities
                                vals
                                (some (fn [entity-candidate]
                                        (and (= (:entity/type entity-candidate) :entity.type/investor)
                                             (not (:common/disabled? entity-candidate))
                                             (= (:investor/legal-entity entity-candidate) selected-entity-id)))))
        options @(rf/subscribe [(case entity-type
                                  :entity.type/company ::sub/add-company-linked-entity-options
                                  :entity.type/person ::sub/add-person-linked-entity-options)
                                ctx])
        options (cond->> options
                  ;; TODO handle this inside rf-subscription:
                  existing-investor?
                  (remove (fn [{:keys [value]}]
                            (= value :entity.type/investor))))
        open-creator (fn [entity-type]
                       (entity/open-creator!
                        entity-type
                        {:initial-values (new-linked-entity-initial-values entity-type selected-entity-id)
                         :dispatch-on-create-nev-2024 [::event/create-linked-entity-success ctx]
                         :prevent-open-entity-after-create? true}))
        create-investor-profile! (fn []
                                   (entity-actions/*->create
                                    {:entity/type            :entity.type/investor
                                     :investor/legal-entity selected-entity-id
                                     :investor/name         (common-entity/display-string selected-entity :long)}
                                    (fn [{:keys [body]}]
                                      (rf/dispatch [::event/create-linked-entity-success ctx {:entity body}]))
                                    (fn [err]
                                      (logging/error "Failed to create investor-profile from NEV action" err))))]
    (when (seq options)
      (if (cu/one-element? options)
        (let [{:keys [value label]} (first options)]
          [button/sm-primary-solid
           {:on-click #(if (= value :entity.type/investor)
                         (create-investor-profile!)
                         (open-creator value))}
           [:i {:class "fal fa-plus"}]
           [:span (str (loc/tr :add) " " (string/lower-case label))]])

        [dropdown-menu/view
         {:items (->> options
                      (mapv (fn [{:keys [value] :as item}]
                              (assoc item :on-click #(if (= value :entity.type/investor)
                                                       (create-investor-profile!)
                                                       (open-creator value))))))
          :props {:hide-arrow? true
                  :align :end}
          :trigger-as-child
          [:span
           [button/sm-primary-solid
            {}
            [:i {:class "fal fa-plus"}]
            [:span (loc/tr :add)]]]}]))))

(defn counterparty-diligence-actions
  [{:keys [ctx] :as _props}]
  (let [counterparty-diligence @(rf/subscribe [::sub/primary-entity ctx])
        entities @(rf/subscribe [::sub/all-cached-entities ctx])
        responders (->> counterparty-diligence
                        :counterparty-diligence/responder
                        (mapv #(get entities %)))
        latest-process (->> counterparty-diligence
                            :counterparty-diligence/processes
                            (mapv #(get entities %))
                            (sort-by :common/created-on)
                            last)]
    [:div
     [cpd-responder-modal/view
      {:process latest-process
       :counterparty-diligence counterparty-diligence
       :responders responders
       :on-success-event [::event/increment-card-remount-counter ctx]
       :refetch-data-event [::event/increment-card-remount-counter ctx]}]]))

(defn view
  [{:keys [entity-type] :as props}]
  (cond
    (#{:entity.type/company :entity.type/person} entity-type)
    [add-linked-entity-button-or-dropdown props]

    (entity-types/counterparty-diligence-entity-type? entity-type)
    [counterparty-diligence-actions props]
    :else
    nil))
